/**
 * @generated SignedSource<<6830318837c4983912531d0edae09cd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type profileNotificationsSettings_Query$variables = {};
export type profileNotificationsSettings_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"profileNotificationsSettings_viewer">;
  } | null;
};
export type profileNotificationsSettings_Query = {
  variables: profileNotificationsSettings_Query$variables;
  response: profileNotificationsSettings_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "settings_notifications"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"settings_notifications\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectStatusChange",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedProject",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnPersonJoin",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectDeadline",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTask",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTaskUpdate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDeadline",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnMention",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableNotifications",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDescriptionChange",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskTitleChange",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEstimateChange",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStartDateChange",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEndDateChange",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSprintChange",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskPhaseChange",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStatusColumnChange",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskProjectChange",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskChange",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskEstimateChange",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskCommentChange",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskFileChange",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBugChange",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBlockedChange",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskRepeatingChange",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDueDate",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceOverdue",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDaysOverdue",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceCreatedOrDeleted",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceStatusChange",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDateReached",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoicePayment",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDateChanged",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDueDateChanged",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTimeOffManager",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTimeOffOwner",
  "storageKey": null
},
v39 = [
  (v11/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "profileNotificationsSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "profileNotificationsSettings_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "profileNotificationsSettings_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slackId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamsEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newSlackEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTimeOffApproval",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationFrequency",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectDeadlineNotificationPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskDeadlineNotificationPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceNotificationDaysOverdue",
            "storageKey": null
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnProjectStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnAssignedProject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnPersonJoin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnProjectDeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnAssignedTask",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnAssignedTaskUpdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskDeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnMention",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disableInAppNotifications",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskDescriptionChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskTitleChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskEstimateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskStartDateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskEndDateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskSprintChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskPhaseChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskStatusColumnChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskProjectChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskSubtaskChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskSubtaskEstimateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskCommentChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskFileChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskBugChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskBlockedChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskRepeatingChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceOverdue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDaysOverdue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceCreatedOrDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDateReached",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoicePayment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDateChanged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDueDateChanged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTimeOffManager",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTimeOffOwner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonNotificationSettingsType",
            "kind": "LinkedField",
            "name": "personNotificationSettings",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectDeadlineOnlyAssignedProjects",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stateChangedOnlyAssignedProjects",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDueDateOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceOverdueOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDaysOverdueOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceCreatedOrDeletedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceStatusChangeOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDateReachedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoicePaymentOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDateChangedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDueDateChangedOnlyOwned",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationSettingsType",
            "kind": "LinkedField",
            "name": "teamsNotificationSettings",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationSettingsType",
            "kind": "LinkedField",
            "name": "slackNotificationSettings",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6d464a4b2fc99a6dec2bcfa1a732a89",
    "id": null,
    "metadata": {},
    "name": "profileNotificationsSettings_Query",
    "operationKind": "query",
    "text": "query profileNotificationsSettings_Query {\n  viewer {\n    actualPersonId\n    component(name: \"settings_notifications\")\n    ...profileNotificationsSettings_viewer\n    id\n  }\n}\n\nfragment profileNotificationsSettings_viewer on Viewer {\n  id\n  slackId\n  availableFeatureFlags {\n    key\n    id\n  }\n  company {\n    teamsEnabled\n    newSlackEnabled\n    useTimeOffApproval\n    id\n  }\n  actualPersonId\n  notificationFrequency\n  notifyOnProjectStatusChange\n  notifyOnAssignedProject\n  notifyOnPersonJoin\n  notifyOnProjectDeadline\n  notifyOnAssignedTask\n  notifyOnAssignedTaskUpdate\n  notifyOnTaskDeadline\n  notifyOnMention\n  disableNotifications\n  projectDeadlineNotificationPeriod\n  taskDeadlineNotificationPeriod\n  invoiceNotificationDaysOverdue\n  notifyOnTaskDescriptionChange\n  notifyOnTaskTitleChange\n  notifyOnTaskEstimateChange\n  notifyOnTaskStartDateChange\n  notifyOnTaskEndDateChange\n  notifyOnTaskSprintChange\n  notifyOnTaskPhaseChange\n  notifyOnTaskStatusColumnChange\n  notifyOnTaskProjectChange\n  notifyOnTaskSubtaskChange\n  notifyOnTaskSubtaskEstimateChange\n  notifyOnTaskCommentChange\n  notifyOnTaskFileChange\n  notifyOnTaskBugChange\n  notifyOnTaskBlockedChange\n  notifyOnTaskRepeatingChange\n  notifyOnInvoiceDueDate\n  notifyOnInvoiceOverdue\n  notifyOnInvoiceDaysOverdue\n  notifyOnInvoiceCreatedOrDeleted\n  notifyOnInvoiceStatusChange\n  notifyOnInvoiceDateReached\n  notifyOnInvoicePayment\n  notifyOnInvoiceDateChanged\n  notifyOnInvoiceDueDateChanged\n  notifyOnTimeOffManager\n  notifyOnTimeOffOwner\n  notifyInAppOnProjectStatusChange\n  notifyInAppOnAssignedProject\n  notifyInAppOnPersonJoin\n  notifyInAppOnProjectDeadline\n  notifyInAppOnAssignedTask\n  notifyInAppOnAssignedTaskUpdate\n  notifyInAppOnTaskDeadline\n  notifyInAppOnMention\n  disableInAppNotifications\n  notifyInAppOnTaskDescriptionChange\n  notifyInAppOnTaskTitleChange\n  notifyInAppOnTaskEstimateChange\n  notifyInAppOnTaskStartDateChange\n  notifyInAppOnTaskEndDateChange\n  notifyInAppOnTaskSprintChange\n  notifyInAppOnTaskPhaseChange\n  notifyInAppOnTaskStatusColumnChange\n  notifyInAppOnTaskProjectChange\n  notifyInAppOnTaskSubtaskChange\n  notifyInAppOnTaskSubtaskEstimateChange\n  notifyInAppOnTaskCommentChange\n  notifyInAppOnTaskFileChange\n  notifyInAppOnTaskBugChange\n  notifyInAppOnTaskBlockedChange\n  notifyInAppOnTaskRepeatingChange\n  notifyInAppOnInvoiceDueDate\n  notifyInAppOnInvoiceOverdue\n  notifyInAppOnInvoiceDaysOverdue\n  notifyInAppOnInvoiceCreatedOrDeleted\n  notifyInAppOnInvoiceStatusChange\n  notifyInAppOnInvoiceDateReached\n  notifyInAppOnInvoicePayment\n  notifyInAppOnInvoiceDateChanged\n  notifyInAppOnInvoiceDueDateChanged\n  notifyInAppOnTimeOffManager\n  notifyInAppOnTimeOffOwner\n  personNotificationSettings {\n    id\n    projectDeadlineOnlyAssignedProjects\n    stateChangedOnlyAssignedProjects\n    invoiceDueDateOnlyOwned\n    invoiceOverdueOnlyOwned\n    invoiceDaysOverdueOnlyOwned\n    invoiceCreatedOrDeletedOnlyOwned\n    invoiceStatusChangeOnlyOwned\n    invoiceDateReachedOnlyOwned\n    invoicePaymentOnlyOwned\n    invoiceDateChangedOnlyOwned\n    invoiceDueDateChangedOnlyOwned\n  }\n  teamsNotificationSettings {\n    disableNotifications\n    notifyOnProjectStatusChange\n    notifyOnAssignedProject\n    notifyOnPersonJoin\n    notifyOnProjectDeadline\n    notifyOnAssignedTask\n    notifyOnAssignedTaskUpdate\n    notifyOnTaskDeadline\n    notifyOnMention\n    notifyOnTaskDescriptionChange\n    notifyOnTaskTitleChange\n    notifyOnTaskEstimateChange\n    notifyOnTaskStartDateChange\n    notifyOnTaskEndDateChange\n    notifyOnTaskSprintChange\n    notifyOnTaskPhaseChange\n    notifyOnTaskStatusColumnChange\n    notifyOnTaskProjectChange\n    notifyOnTaskSubtaskChange\n    notifyOnTaskSubtaskEstimateChange\n    notifyOnTaskCommentChange\n    notifyOnTaskFileChange\n    notifyOnTaskBugChange\n    notifyOnTaskBlockedChange\n    notifyOnTaskRepeatingChange\n    notifyOnInvoiceDueDate\n    notifyOnInvoiceOverdue\n    notifyOnInvoiceDaysOverdue\n    notifyOnInvoiceCreatedOrDeleted\n    notifyOnInvoiceStatusChange\n    notifyOnInvoiceDateReached\n    notifyOnInvoicePayment\n    notifyOnInvoiceDateChanged\n    notifyOnInvoiceDueDateChanged\n    notifyOnTimeOffManager\n    notifyOnTimeOffOwner\n  }\n  slackNotificationSettings {\n    disableNotifications\n    notifyOnProjectStatusChange\n    notifyOnAssignedProject\n    notifyOnPersonJoin\n    notifyOnProjectDeadline\n    notifyOnAssignedTask\n    notifyOnAssignedTaskUpdate\n    notifyOnTaskDeadline\n    notifyOnMention\n    notifyOnTaskDescriptionChange\n    notifyOnTaskTitleChange\n    notifyOnTaskEstimateChange\n    notifyOnTaskStartDateChange\n    notifyOnTaskEndDateChange\n    notifyOnTaskSprintChange\n    notifyOnTaskPhaseChange\n    notifyOnTaskStatusColumnChange\n    notifyOnTaskProjectChange\n    notifyOnTaskSubtaskChange\n    notifyOnTaskSubtaskEstimateChange\n    notifyOnTaskCommentChange\n    notifyOnTaskFileChange\n    notifyOnTaskBugChange\n    notifyOnTaskBlockedChange\n    notifyOnTaskRepeatingChange\n    notifyOnInvoiceDueDate\n    notifyOnInvoiceOverdue\n    notifyOnInvoiceDaysOverdue\n    notifyOnInvoiceCreatedOrDeleted\n    notifyOnInvoiceStatusChange\n    notifyOnInvoiceDateReached\n    notifyOnInvoicePayment\n    notifyOnInvoiceDateChanged\n    notifyOnInvoiceDueDateChanged\n    notifyOnTimeOffManager\n    notifyOnTimeOffOwner\n  }\n}\n"
  }
};
})();

(node as any).hash = "7873cae11e97b61ccb0a2fa94bc78796";

export default node;
